import { render, staticRenderFns } from "./ManualDataList.vue?vue&type=template&id=18f60d82"
import script from "./ManualDataList.vue?vue&type=script&lang=js"
export * from "./ManualDataList.vue?vue&type=script&lang=js"
import style0 from "./ManualDataList.vue?vue&type=style&index=0&id=18f60d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports